<div class="container">
  <div class="content">{{ text }}</div>
  <div class="icon">
    <img [src]="url" alt="" />
  </div>
</div>
